import { render, staticRenderFns } from "./HelpdeskWrite.vue?vue&type=template&id=1e00885f"
import script from "./HelpdeskWrite.ts?vue&type=script&lang=ts&external"
export * from "./HelpdeskWrite.ts?vue&type=script&lang=ts&external"
import style0 from "./HelpdeskWrite.vue?vue&type=style&index=0&id=1e00885f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports